import { serviceApi } from '~/api/service';
import qs from 'qs';

const slotsUrl = (queryParams) => `date-slots?${queryParams}`;

export const dateSlotsApi = {
  getDateSlots: (storeId, appointmentTypeIds, startDate, endDate, partnerId) => {
    const queryParams = qs.stringify(
      {
        storeId,
        appointmentTypeIds: appointmentTypeIds.join(','),
        startDate,
        endDate,
        partnerId: partnerId || null /** avoid empty query */,
      },
      { skipNulls: true, encode: false },
    );
    return serviceApi.fetchJSON(slotsUrl(queryParams));
  },
};
